var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.267,
    height: 49.406,
    viewBox: "0 0 49.267 49.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "np_trophy_670335_000000",
    x: 0,
    y: 0,
    width: 49.267,
    height: 49.406,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4379",
    "data-name": "Group 4379",
    transform: "translate(9.625 6.625)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.62, -6.63)",
    filter: "url(#np_trophy_670335_000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "np_trophy_670335_000000-2",
    "data-name": "np_trophy_670335_000000",
    d: "M10.02,17.34h.791a8.924,8.924,0,0,0,6.241,5.032V25.3H14.866a1.222,1.222,0,0,0-1.222,1.222v1.6h-1.09a.776.776,0,0,0-.789.794v4.166a.779.779,0,0,0,.779.779H25.307a.778.778,0,0,0,.791-.779V28.923a.779.779,0,0,0-.779-.779h-1.1v-1.6A1.221,1.221,0,0,0,23,25.321H20.811V22.373a8.923,8.923,0,0,0,6.241-5.032h.791a6.1,6.1,0,0,0,6.095-6.1v-3.7a.977.977,0,0,0-.977-.977H27.844V4.689a.977.977,0,0,0-.977-.977H10.993a.977.977,0,0,0-.977.977V6.566H4.9a.977.977,0,0,0-.977.977v3.7a6.093,6.093,0,0,0,6.1,6.1Zm17.824-3.671V9.65h3.011v1.593h0a3.014,3.014,0,0,1-3.011,3.011h-.019c.009-.192.019-.388.019-.583ZM15.121,10.946h0l2.2-.326a.386.386,0,0,0,.286-.209l.977-1.99a.381.381,0,0,1,.685,0l.977,1.99a.382.382,0,0,0,.286.209l2.2.326a.381.381,0,0,1,.211.651l-1.589,1.551h0a.384.384,0,0,0-.111.326l.374,2.189a.38.38,0,0,1-.554.4l-1.954-1.033A22.976,22.976,0,0,1,16.8,16.064h0l-.388-.027H16.4a.38.38,0,0,1-.153-.373l.374-2.189a.38.38,0,0,0-.111-.326L14.919,11.6c-.251-.018-.27-.358-.229-.487s.289-.141.432-.164Zm-8.11-1.3H10.02v4.026c0,.2,0,.391.019.583H10.02a3.014,3.014,0,0,1-3.011-3.011Z",
    transform: "translate(5.7 2.91)",
    fill: "#f3f2ef",
    stroke: "#121e59",
    strokeWidth: 1.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M0,0H12V12H0Z",
    transform: "translate(9.008 2.578)",
    fill: "#f3f2ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_87",
    "data-name": "Polygon 87",
    d: "M4.552.9a.5.5,0,0,1,.9,0L6.38,2.779a.5.5,0,0,0,.389.274l2.126.253a.5.5,0,0,1,.273.87L7.642,5.53A.5.5,0,0,0,7.484,6l.4,1.97a.5.5,0,0,1-.721.543L5.231,7.51a.5.5,0,0,0-.462,0L2.839,8.516a.5.5,0,0,1-.721-.543L2.516,6a.5.5,0,0,0-.158-.473L.833,4.177a.5.5,0,0,1,.273-.87l2.126-.253a.5.5,0,0,0,.389-.274Z",
    transform: "translate(10.008 3.578)",
    fill: "#f3f2ef"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyIcon);
export default __webpack_public_path__ + "static/media/trophyIcon.23846fc9f787048301d404231723b172.svg";
export { ForwardRef as ReactComponent };